// extracted by mini-css-extract-plugin
export default {"loading":"topicDetail_loading__DTyAu","pcWrap":"topicDetail_pcWrap__UffB1"};